import { useEffect, useMemo } from 'react';
import { useDispatch, useSelector, shallowEqual } from 'react-redux';
import { fetchPlans, generateApplicationOffer } from '../state/application';

const useApplicationOffer = () => {
  const dispatch = useDispatch();

  const { userID: policyHolderUserId } = useSelector((state) => state.app.user);
  const { addons, startDate, endDate, hasEndDate } = useSelector(
    (state) => state.nomadInsurance.purchaseInsurance.coverage
  );
  const { beneficiary, phoneNumber, phoneCountryCode, gender } = useSelector(
    (state) => state.nomadInsurance.purchaseInsurance.basicInfo
  );
  const { previousApplicantsIds } = useSelector(
    (state) => state.nomadInsurance.purchaseInsurance.applicants,
    shallowEqual
  );
  const applicants = useSelector(
    (state) => state.nomadInsurance.application.applicants,
    shallowEqual
  );
  const groupMembers = useSelector(
    (state) => state.nomadInsurance.application.groupMembers,
    shallowEqual
  );
  const { plans } = useSelector((state) => state.nomadInsurance.application);

  useEffect(() => dispatch(fetchPlans()), [dispatch]);

  const applicantsUserIds = useMemo(() => {
    if (
      previousApplicantsIds?.length > 0 &&
      (!groupMembers || groupMembers.length === 0)
    ) {
      return previousApplicantsIds;
    }
    return applicants?.length > 0 ? applicants : [];
  }, [previousApplicantsIds, groupMembers, applicants]);

  useEffect(() => {
    if (plans && startDate) {
      const startDateFormatted = startDate.slice(0, 10);
      const endDateFormatted = hasEndDate && endDate ? endDate.slice(0, 10) : null;
      dispatch(
        generateApplicationOffer(
          policyHolderUserId,
          applicantsUserIds,
          addons,
          startDateFormatted,
          endDateFormatted,
          beneficiary,
          phoneNumber,
          phoneCountryCode,
          gender
        )
      );
    }
  }, [
    dispatch,
    addons,
    startDate,
    endDate,
    hasEndDate,
    plans,
    previousApplicantsIds,
    beneficiary,
    phoneNumber,
    phoneCountryCode,
    gender
  ]);
};

export default useApplicationOffer;
